export const solicitudesAdapter = (rawData) => {
  const { data } = rawData;
  if (data?.length > 0) {
    const rows = data?.map((item) => {

      const {
        NROSOLICITUD,
        FECHAALTA,
        TIPOSOLICITUD,
        MEDIODEPAGO,
        IMPORTE,
        ESTADO,
        OBSERVACIONES,
        SE_NOMBRE,
        FECHAMODIFICACION,
        RG_ID
      } = item;
      const nroSolicitud = Number(NROSOLICITUD);
      return {
        nDeSolicitud: {
          descripcion: NROSOLICITUD,
          url: `/${nroSolicitud}/detalle-de-solicitud`,
          target: '',
        },
        fecha: FECHAALTA,
        tipo: TIPOSOLICITUD,
        medioDePago: MEDIODEPAGO,
        importe: IMPORTE,
        importeFormateado: new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS',
          minimumFractionDigits: 2}).format(IMPORTE),
        estado: ESTADO,
        nro: NROSOLICITUD,
        observaciones: OBSERVACIONES,
        autorizanteModif: SE_NOMBRE ? SE_NOMBRE.split(" (")[0] : "",
        nro_gestion: RG_ID,
        abonado: ESTADO === "Pagado" ? FECHAMODIFICACION : "",
        acciones: {
          descripcion: 'Ver más',
          url: `/${nroSolicitud}/detalle-de-solicitud`,
          target: '',
        },
      };
    });
    return { rows: rows };
  }
};
